export {MediaSlider} from './lib/media-slider';